import React from 'react';
import { Button, Form, Space } from 'antd';
import type { EpcInvitationKind } from '@/constants/epcInvitationKind';
import {
  parseInvitationDossier,
  type EpcInvitationDossier,
} from '@/constants/epcInvitationWorkflow';
import { EpcInvitationDossierFields } from './EpcInvitationDossierFields';

export const EpcInvitationDossierEditor: React.FC<{
  kind: EpcInvitationKind | 'PQ';
  meta: unknown;
  saving?: boolean;
  onSave: (dossier: EpcInvitationDossier) => void;
}> = ({ kind, meta, saving, onSave }) => {
  const [form] = Form.useForm();
  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={{ dossier: parseInvitationDossier(meta, kind) }}
      onFinish={(values) => onSave(values.dossier as EpcInvitationDossier)}
    >
      <EpcInvitationDossierFields kind={kind} />
      <Space style={{ marginTop: 12 }}>
        <Button type="primary" htmlType="submit" loading={saving}>
          Save dossier
        </Button>
      </Space>
    </Form>
  );
};
